"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.executeManualTransactions = void 0;
const tslib_1 = require("tslib");
const ethers_1 = require("ethers");
const builder_1 = require("../builder");
const encode_1 = require("../encode");
const abis_1 = require("../abis");
function executeManualTransactions(signer, transactions, overrides) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const from = yield signer.getAddress();
        const aggTxn = builder_1.aggregateTransaction(transactions);
        const sig = encode_1.abiEncodePacked({ type: "uint256", value: from }, // r
        { type: "uint256", value: 0 }, // s
        { type: "uint8", value: 1 });
        const safeAddress = builder_1.deriveSafe(from);
        const safeContract = new ethers_1.ethers.Contract(safeAddress, abis_1.safeAbi, signer);
        if (overrides.gasLimit == undefined) {
            const gasLimit = yield safeContract.estimateGas.execTransaction(aggTxn.to, aggTxn.value, aggTxn.data, aggTxn.operation, 0, 0, 0, ethers_1.ethers.constants.AddressZero, ethers_1.ethers.constants.AddressZero, sig);
            console.log(`Estimated gas Limit: ${gasLimit}`);
            overrides.gasLimit = gasLimit;
        }
        return safeContract.execTransaction(aggTxn.to, aggTxn.value, aggTxn.data, aggTxn.operation, 0, 0, 0, ethers_1.ethers.constants.AddressZero, ethers_1.ethers.constants.AddressZero, sig, overrides);
    });
}
exports.executeManualTransactions = executeManualTransactions;
